module.exports = __webpack_public_path__ + "static/media/Mod4.bcbb6661.png";